<phc-accordion aria-label="Use available cash to buy">
  <header>
    <p class="plan-and-take-action--accordion-header">
      <b>Use available cash to buy:</b> Avoid missing out on potential returns
    </p>
  </header>
  <content>
    <div class="plan-and-take-action-accordion-content">
      <ol>
        <li class="plan-and-take-action-accordion-content-item">Determine what to buy</li>
        <ul class="plan-and-take-action-accordion-content--text">
          <li class="plan-and-take-action-accordion-content--text-item">
            Compare the stock, bond, and cash asset type percentages with your targets
          </li>
          <li>Determine the differences between the current and target allocations</li>
          <li>Buy assets that you have less of to better align to your targets</li>
        </ul>
        <li class="plan-and-take-action-accordion-content-item">Invest your cash</li>
      </ol>
      <p>
        Need more stocks? Either buy more of the stocks you already own or buy new stock
        investments.
      </p>
      <ul class="plan-and-take-action-accordion-content--text-link">
        <li>
          <a
            c11n-link
            [href]="urls.reviewMyStocksReviewMyBonds"
            target="_blank"
            [variant]="'secondary-independent'"
            aria-label="Review my stocks"
            (click)="callToAction('review-my-stocks', 'Text-Link')"
            >Review my stocks</a
          >
        </li>
        <li>
          <a
            c11n-link
            [href]="urls.allStockFunds"
            target="_blank"
            [variant]="'secondary-independent'"
            aria-label="View all stock funds"
            (click)="callToAction('view-all-stocks-funds', 'Text-Link')"
            >View all stock funds</a
          >
        </li>
      </ul>
      <p>
        Need more bonds? Either buy more of the bonds you already own or buy new bond investments.
      </p>
      <ul class="plan-and-take-action-accordion-content--text-link">
        <li>
          <a
            c11n-link
            [href]="urls.reviewMyStocksReviewMyBonds"
            target="_blank"
            [variant]="'secondary-independent'"
            aria-label="Review my bonds"
            (click)="callToAction('review-my-bonds', 'Text-Link')"
            >Review my bonds</a
          >
        </li>
        <li>
          <a
            c11n-link
            [href]="urls.allBondsFunds"
            target="_blank"
            [variant]="'secondary-independent'"
            aria-label="View all bond funds"
            (click)="callToAction('view-all-bond-funds', 'Text-Link')"
            >View all bond funds</a
          >
        </li>
        <li>
          <a
            c11n-link
            [href]="urls.allBonds"
            target="_blank"
            [variant]="'secondary-independent'"
            aria-label="View all bonds"
            (click)="callToAction('view-all-bonds', 'Text-Link')"
            >View all bonds</a
          >
        </li>
      </ul>
    </div>
  </content>
</phc-accordion>
